import firebase from "firebase";
import _ from "lodash";
import db from "./db.js";
import { OlabPrimer } from "./olabprimer.js";
import { OlabUtils } from "./olabutils.js";

class OlabDesign {
  constructor(dsgn) {
    // OlabUtils.infoLog("OlabDesign.constructor() ...");
    if (dsgn == null) {
      this.initDesign();
    } else {
      let hp = Object.prototype.hasOwnProperty;
      this.olab_id = hp.call(dsgn, "olab_id") ? dsgn.olab_id : null;
      this.olab_type = hp.call(dsgn, "olab_type") ? dsgn.olab_type : null;
      this.name = hp.call(dsgn, "name") ? dsgn.name : null;
      this.name_uc = hp.call(dsgn, "name_uc") ? dsgn.name_uc : null;
      this.creator = hp.call(dsgn, "creator") ? dsgn.creator : null;
      this.creator_uc = hp.call(dsgn, "creator_uc") ? dsgn.creator_uc : null;
      this.desc = hp.call(dsgn, "desc") ? dsgn.desc : null;
      this.project_id = hp.call(dsgn, "project_id") ? dsgn.project_id : null;
      this.cart_id = hp.call(dsgn, "cart_id") ? dsgn.cart_id : null;
      this.configured = hp.call(dsgn, "configured") ? dsgn.configured : false;
      this.pmr_setting = hp.call(dsgn, "pmr_setting")
        ? dsgn.pmr_setting
        : "FULL";
      this.pmr_3p_len = hp.call(dsgn, "pmr_3p_len") ? dsgn.pmr_3p_len : 20;
      this.pmr_5p_len = hp.call(dsgn, "pmr_5p_len") ? dsgn.pmr_5p_len : 20;
      this.package_present = hp.call(dsgn, "package_present")
        ? dsgn.package_present
        : false;
      this.cstArray = hp.call(dsgn, "cstArray") ? dsgn.cstArray : [];
      this.combPmrArray = hp.call(dsgn, "combPmrArray")
        ? dsgn.combPmrArray
        : [];
      this.uniqPmrArray = hp.call(dsgn, "uniqPmrArray")
        ? dsgn.uniqPmrArray
        : [];
      this.processing = hp.call(dsgn, "processing") ? dsgn.processing : "";
    }
  }

  static getOlabDesignConverter() {
    // Firestore data converter
    let olabDesignConverter = {
      toFirestore: function(dsgn) {
        return {
          olab_id: dsgn.olab_id,
          olab_type: dsgn.olab_type,
          name: dsgn.name,
          name_uc: dsgn.name_uc,
          creator: dsgn.creator,
          creator_uc: dsgn.creator_uc,
          desc: dsgn.desc,
          project_id: dsgn.project_id,
          cart_id: dsgn.cart_id,
          configured: dsgn.configured,
          pmr_setting: dsgn.pmr_setting,
          pmr_3p_len: dsgn.pmr_3p_len,
          pmr_5p_len: dsgn.pmr_5p_len,
          package_present: dsgn.package_present,
          // cstArray: dsgn.cstArray,
          // combPmrArray: dsgn.combPmrArray,
          uniqPmrArray: dsgn.uniqPmrArray
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabDesign(data);
      }
    };
    return olabDesignConverter;
  }

  static getCreateDesignConverter() {
    // Firestore data converter
    let olabDesignConverter = {
      toFirestore: function(dsgn) {
        return {
          olab_id: dsgn.olab_id,
          olab_type: dsgn.olab_type,
          name: dsgn.name,
          name_uc: dsgn.name_uc,
          creator: dsgn.creator,
          creator_uc: dsgn.creator_uc,
          desc: dsgn.desc,
          project_id: dsgn.project_id,
          cart_id: dsgn.cart_id,
          configured: dsgn.configured,
          pmr_setting: dsgn.pmr_setting,
          pmr_3p_len: dsgn.pmr_3p_len,
          pmr_5p_len: dsgn.pmr_5p_len,
          package_present: dsgn.package_present,
          // cstArray: dsgn.cstArray,
          // combPmrArray: dsgn.combPmrArray,
          uniqPmrArray: dsgn.uniqPmrArray,
          created_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabDesign(data);
      }
    };
    return olabDesignConverter;
  }

  static getUpdateDesignConverter() {
    // Firestore data converter
    let olabDesignConverter = {
      toFirestore: function(dsgn) {
        return {
          olab_id: dsgn.olab_id,
          olab_type: dsgn.olab_type,
          name: dsgn.name,
          name_uc: dsgn.name_uc,
          creator: dsgn.creator,
          creator_uc: dsgn.creator_uc,
          desc: dsgn.desc,
          project_id: dsgn.project_id,
          cart_id: dsgn.cart_id,
          configured: dsgn.configured,
          pmr_setting: dsgn.pmr_setting,
          pmr_3p_len: dsgn.pmr_3p_len,
          pmr_5p_len: dsgn.pmr_5p_len,
          package_present: dsgn.package_present,
          // cstArray: dsgn.cstArray,
          // combPmrArray: dsgn.combPmrArray,
          uniqPmrArray: dsgn.uniqPmrArray,
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabDesign(data);
      }
    };
    return olabDesignConverter;
  }

  initDesign() {
    OlabUtils.infoLog("OlabDesign.initDesign() ...");
    // Common fields: internal use
    this.olab_id = null;
    this.olab_type = null;
    this.name_uc = null;
    this.creator_uc = null;

    this.name = null;
    this.desc = null;
    this.project_id = null;
    this.cart_id = null;
    this.configured = false;
    this.pmr_setting = "FULL";
    this.pmr_3p_len = 20;
    this.pmr_5p_len = 20;
    this.package_present = false;
    this.cstArray = null;
    this.combPmrArray = null;
    this.uniqPmrArray = null;
    // For UI visual cue use only
    this.processing = "";
  }

  static getUCID(str, id) {
    let str_uc = null;
    // append id to str for search to work later
    if (str != null) {
      str_uc = str.toUpperCase() + " ^%#- " + id;
    }
    return str_uc;
  }

  set(dsgn) {
    this.olab_id = dsgn.olab_id;
    this.olab_type = dsgn.olab_type;
    this.name = dsgn.name;
    // append unique key to name_uc for search to work later
    this.name_uc = OlabDesign.getUCID(this.name, this.olab_id);
    this.creator = dsgn.creator;
    // append unique key to creator_uc for search to work later
    this.creator_uc = OlabDesign.getUCID(this.creator, this.olab_id);

    this.cart_id = dsgn.olab_id;
    this.project_id = dsgn.project_id;
    this.desc = dsgn.desc;
    this.configured = dsgn.configured;
    this.pmr_setting = dsgn.pmr_setting;
    this.pmr_3p_len = dsgn.pmr_3p_len;
    this.pmr_5p_len = dsgn.pmr_5p_len;
    this.package_present = dsgn.package_present;
    this.cstArray = dsgn.cstArray;
    this.combPmrArray = dsgn.combPmrArray;
    this.uniqPmrArray = dsgn.uniqPmrArray;
  }

  setCart(cart, type) {
    if (cart.design_id) {
      this.olab_id = cart.design_id;
      this.name = cart.design_name;
    } else {
      let designID = cart.olab_id;
      designID = designID.substr(5, designID.length);
      designID = "DS" + designID;
      this.olab_id = designID;
      this.name = "Design using " + cart.name;
      // Assign id and name to cart's design properties
      cart.design_id = this.olab_id;
      cart.design_name = this.name;
    }

    // append unique key to name_uc for search to work later
    this.name_uc = OlabDesign.getUCID(this.name, this.olab_id);
    this.creator = cart.creator;
    // append unique key to creator_uc for search to work later
    this.creator_uc = OlabDesign.getUCID(this.creator, this.olab_id);

    this.olab_type = type;
    this.cart_id = cart.olab_id;
    this.project_id = cart.project_id;

    // Reset the rest
    this.desc = null;
    this.configured = false;
    this.pmr_setting = "FULL";
    this.pmr_3p_len = 20;
    this.pmr_5p_len = 20;
    this.package_present = false;
    this.cstArray = null;
    this.combPmrArray = null;
    this.uniqPmrArray = null;
  }

  static saveDesign(dsgn) {
    // // transform array of specific classes into array of pure JavaScript objects
    // for (let i = 0; i < dsgn.cstArray.length; i++) {
    //   // dsgn.cstArray[i].cstbs = dsgn.cstArray[i].cstbs.map((obj) => { return Object.assign({}, obj) });
    //   dsgn.cstArray[i].forwards = dsgn.cstArray[i].forwards.map((obj) => { return Object.assign({}, obj) });
    //   dsgn.cstArray[i].backwards = dsgn.cstArray[i].backwards.map((obj) => { return Object.assign({}, obj) });
    // }
    // dsgn.combPmrArray = dsgn.combPmrArray.map((obj) => { return Object.assign({}, obj) });
    dsgn.uniqPmrArray = dsgn.uniqPmrArray.map(obj => {
      return Object.assign({}, obj);
    });

    const dsgnRef = "designs/BX/olab_designs/";
    db.collection(dsgnRef)
      .withConverter(OlabDesign.getUpdateDesignConverter())
      .doc(dsgn.olab_id)
      .set(dsgn, { merge: true })
      .then(() => {
        OlabUtils.infoLog("saveDesign: Document successfully written!");
        // For UI visual cue use only
        dsgn.processing = "";
      })
      .catch(error => {
        OlabUtils.infoLog("saveDesign: Error writing document: ", error);
        this.error = error;
        // For UI visual cue use only
        dsgn.processing = "";
      });
  }

  static getCompName(comp) {
    let name = null;
    if (comp.name) {
      name = comp.name;
    } else if (comp.old_locus_tag) {
      name = comp.old_locus_tag;
    } else if (comp.locus_tag) {
      name = comp.locus_tag;
    } else {
      name = comp.olab_id;
    }
    return name;
  }

  static createCompCstb(box, comp) {
    if (box && comp) {
      // Create a cstb for comp
      const cstb = {
        box_id: box.cstb.box_id,
        display_name: box.cstb.suffix + OlabDesign.getCompName(comp),
        box_type: box.cstb.box_type,
        suffix: box.cstb.suffix,
        start: 0,
        range: comp.length,
        primer_type: "default",
        btn_color: box.cstb.btn_color,
        btn_state: box.cstb.btn_state,
        use_seq_as_color: box.cstb.use_seq_as_color,
        configured: true,
        comp_olab_id: comp.olab_id,
        seq: comp.seq
      };
      return cstb;
    }
    return null;
  }

  buildCsbts(box) {
    let tmpCstbs = [];
    if (box.item.comp.olab_type == "package") {
      this.package_present = true;
      // comps is the list of items in the package
      const comps = box.item.seq.comps;
      for (const comp of comps) {
        // Create a cstb for each comp
        tmpCstbs.push(OlabDesign.createCompCstb(box, comp));
      }
    } else {
      tmpCstbs.push(box.cstb);
    }
    return tmpCstbs;
  }

  buildPrimerObjs(box, primerObjArr) {
    // OlabUtils.infoLog("buildPrimerObjs: box = " + box + ", primerObjArr.length = " + primerObjArr.length);
    if (box && primerObjArr) {
      OlabUtils.infoLog(
        "buildPrimerObjs: primerObjArr.length = " + primerObjArr.length
      );

      if (box.item.comp.olab_type == "package") {
        this.package_present = true;
        // comps is the list of items in the package
        const comps = box.item.seq.comps;
        for (const comp of comps) {
          const cstbs = [];
          // Create a cstb for each comp
          cstbs.push(OlabDesign.createCompCstb(box, comp));
          primerObjArr.push({
            cstbs: cstbs,
            forwards: [],
            backwards: []
          });
        }
      } else {
        const cstbs = [];
        cstbs.push(box.cstb);
        primerObjArr.push({
          cstbs: cstbs,
          forwards: [],
          backwards: []
        });
      }
      return primerObjArr.length;
    } else {
      OlabUtils.infoLog(
        "buildPrimerObjs - box is null or primerObjArr is null or empty!"
      );
    }
    return 0;
  }

  computePrimersV2(cstBoxes, primerObjArr) {
    OlabUtils.infoLog("*** OlabDesign: ComputePrimersV2 ***");
    OlabUtils.infoLog(
      "*** cstBoxes = " +
        cstBoxes +
        ", primerObjArr.length = " +
        primerObjArr.length
    );

    this.package_present = false;
    if (cstBoxes && cstBoxes.length > 0) {
      let createdPrObjCnt = this.buildPrimerObjs(cstBoxes[0], primerObjArr);

      for (let index = 1; index < cstBoxes.length; index++) {
        if (cstBoxes[index].item == null) {
          OlabUtils.infoLog(
            "Terminate primer computation. cstBoxes[index].item is null!"
          );
          break;
        }
        const snapshotPrObjCnt = createdPrObjCnt;
        const indexBoxCstbs = this.buildCsbts(cstBoxes[index]);
        let cstbsLen = indexBoxCstbs.length;
        OlabUtils.infoLog(
          "snapshotPrObjCnt = " +
            snapshotPrObjCnt +
            ", cstbsLen = " +
            cstbsLen +
            ", package_op = " +
            cstBoxes[index].cstb.package_op
        );
        if (cstBoxes[index].cstb.package_op == "linear") {
          OlabUtils.infoLog("package_op == linear");
          if (cstbsLen > snapshotPrObjCnt) {
            OlabUtils.infoLog("** cstbsLen > snapshotPrObjCnt");
            // Copy the last primerObjArr element and duplicate diff times.
            const diff = cstbsLen - snapshotPrObjCnt;
            const lastCstbs = primerObjArr[snapshotPrObjCnt - 1].cstbs.slice();
            for (let i = 0; i < diff; i++) {
              const tmpCstbs = lastCstbs.slice();
              const tmpObj = {
                cstbs: tmpCstbs,
                forwards: [],
                backwards: []
              };
              primerObjArr.push(tmpObj);
            }
          } else if (cstbsLen < snapshotPrObjCnt) {
            OlabUtils.infoLog("** ** cstbsLen < snapshotPrObjCnt");
            // Copy the last indexBox's comp element and duplicate diff times.
            const diff = snapshotPrObjCnt - cstbsLen;
            const comps = cstBoxes[index].item.seq.comps;
            const comp = comps[comps.length - 1];
            for (let i = 0; i < diff; i++) {
              const cstb = OlabDesign.createCompCstb(cstBoxes[index], comp);
              indexBoxCstbs.push(cstb);
            }
            cstbsLen = indexBoxCstbs.length;
          }
          createdPrObjCnt = primerObjArr.length;
          // now we should have cstbsLen == snapshotPrObjCnt
          for (let i = 0; i < cstbsLen; i++) {
            primerObjArr[i].cstbs.push(indexBoxCstbs[i]);
          }
        } else {
          // handle combination or single case
          // Need to multiply for combination case
          if (cstbsLen > 1) {
            const multipler = cstbsLen - 1;
            for (let i = 0; i < multipler; i++) {
              for (let j = 0; j < snapshotPrObjCnt; j++) {
                const tmpCstbs = primerObjArr[j].cstbs.slice();
                const tmpObj = {
                  cstbs: tmpCstbs,
                  forwards: [],
                  backwards: []
                };
                primerObjArr.push(tmpObj);
              }
            }
          }
          createdPrObjCnt = primerObjArr.length;
          for (let i = 0; i < cstbsLen; i++) {
            for (let j = 0; j < snapshotPrObjCnt; j++) {
              const k = i * snapshotPrObjCnt + j;
              primerObjArr[k].cstbs.push(indexBoxCstbs[i]);
            }
          }
        }
      }

      // Classify and compute primers
      let prObjCnt = 0;
      // Switch "DS" to "CS"
      let cstID = this.olab_id.substr(2);
      cstID = "CS" + cstID;
      for (const prObj of primerObjArr) {
        OlabPrimer.classifyPrimers(prObj);
        // prObj's olab_id
        prObj.olab_id = cstID + "-" + prObjCnt.toString().padStart(3, "0");
        prObjCnt++;
        OlabPrimer.computePrimers(
          prObj,
          this.pmr_3p_len,
          this.pmr_5p_len,
          this.pmr_setting
        );
      }
    } else {
      OlabUtils.infoLog(
        "OlabDesign: ComputePrimersV2 - cstBoxes is null or empty!"
      );
    }
  }

  computePrimers(cstBoxes, prObjArr) {
    // Setup
    let createdPrObjCnt = 0;
    this.package_present = false;

    for (const box of cstBoxes) {
      if (box.item == null) {
        OlabUtils.infoLog("Terminate primer computation. box.item is null!");
        break;
      }
      // Initial state
      if (createdPrObjCnt == 0) {
        if (box.item.comp.olab_type == "package") {
          this.package_present = true;
          // comps is the list of items in the package
          const comps = box.item.seq.comps;
          for (const comp of comps) {
            const cstbs = [];
            // Create a temp cstb for each comp
            const tmpCstb = {
              box_id: box.cstb.box_id,
              display_name: box.cstb.suffix + OlabDesign.getCompName(comp),
              box_type: box.cstb.box_type,
              suffix: box.cstb.suffix,
              start: 0,
              range: comp.length,
              primer_type: "default",
              btn_color: box.cstb.btn_color,
              btn_state: box.cstb.btn_state,
              use_seq_as_color: box.cstb.use_seq_as_color,
              configured: true,
              comp_olab_id: comp.olab_id,
              seq: comp.seq
            };
            cstbs.push(tmpCstb);
            prObjArr.push({
              cstbs: cstbs,
              forwards: [],
              backwards: []
            });
          }
          createdPrObjCnt = comps.length;
        } else {
          const cstbs = [];
          cstbs.push(box.cstb);
          prObjArr.push({
            cstbs: cstbs,
            forwards: [],
            backwards: []
          });
          createdPrObjCnt = 1;
        }
      } else {
        // createdPrObjCnt != 0 case
        const snapshotPrObjCnt = createdPrObjCnt;
        let compsLen = 1;
        let tmpCstbArr = [];
        if (box.item.comp.olab_type == "package") {
          this.package_present = true;
          // comps is the list of items in the package
          const comps = box.item.seq.comps;
          compsLen = comps.length;
          for (const comp of comps) {
            // Create a temp cstb for each comp
            const tmpCstb = {
              box_id: box.cstb.box_id,
              display_name: box.cstb.suffix + OlabDesign.getCompName(comp),
              box_type: box.cstb.box_type,
              suffix: box.cstb.suffix,
              start: 0,
              range: comp.length,
              primer_type: "default",
              btn_color: box.cstb.btn_color,
              btn_state: box.cstb.btn_state,
              use_seq_as_color: box.cstb.use_seq_as_color,
              configured: true,
              comp_olab_id: comp.olab_id,
              seq: comp.seq
            };
            tmpCstbArr.push(tmpCstb);
          }
        } else {
          compsLen = 1;
          tmpCstbArr.push(box.cstb);
        }
        // Need to multiply proObjs in proObjArr
        if (compsLen > 1) {
          const multipler = compsLen - 1;
          for (let i = 0; i < multipler; i++) {
            for (let j = 0; j < snapshotPrObjCnt; j++) {
              const tmpCstbs = prObjArr[j].cstbs.slice();
              const tmpObj = {
                cstbs: tmpCstbs,
                forwards: [],
                backwards: []
              };
              prObjArr.push(tmpObj);
            }
          }
        }
        createdPrObjCnt = prObjArr.length;

        for (let i = 0; i < compsLen; i++) {
          for (let j = 0; j < snapshotPrObjCnt; j++) {
            const k = i * snapshotPrObjCnt + j;
            prObjArr[k].cstbs.push(tmpCstbArr[i]);
          }
        }
      }
    }

    // Compute primers for each combination
    let prObjCnt = 0;
    // Switch "DS" to "CS"
    let cstID = this.olab_id.substr(2);
    cstID = "CS" + cstID;
    for (const prObj of prObjArr) {
      OlabPrimer.classifyPrimers(prObj);
      // prObj's olab_id
      prObj.olab_id = cstID + "-" + prObjCnt.toString().padStart(3, "0");
      prObjCnt++;
      OlabPrimer.computePrimers(
        prObj,
        this.pmr_3p_len,
        this.pmr_5p_len,
        this.pmr_setting
      );
    }
  }

  getAllPrimers() {
    // design_id,construct_id, construct_sequence,
    // box_id,box_name,box_size, box_sequence,
    // primer_name_fwd,primer_sequence_fwd,primer_length_fwd,primer_tm_fwd,
    // primer_name_rev,primer_sequence_rev,primer_length_rev,primer_tm_rev

    const resPmrs = [];
    for (let i = 0; i < this.cstArray.length; i++) {
      const cst = this.cstArray[i];
      let constructSeq = "";
      for (let j = 0; j < cst.cstbs.length; j++) {
        constructSeq += cst.cstbs[j].seq;
      }
      OlabUtils.infoLog("constructSeq = " + constructSeq);
      for (let j = 0; j < cst.cstbs.length; j++) {
        const cstb = cst.cstbs[j];
        const fwd = cst.forwards[j];
        const fwdLen = fwd.seq ? fwd.seq.length : 0;
        const bwd = cst.backwards[j];
        const bwdLen = bwd.seq ? bwd.seq.length : 0;
        const pmrObj = {
          primer_tm_rev: parseFloat(bwd.tm.toFixed(2)),
          primer_length_rev: bwdLen,
          primer_sequence_rev: bwd.seq,
          primer_name_rev: bwd.name,
          primer_tm_fwd: parseFloat(fwd.tm.toFixed(2)),
          primer_length_fwd: fwdLen,
          primer_sequence_fwd: fwd.seq,
          primer_name_fwd: fwd.name,
          box_sequence: cstb.seq,
          box_size: cstb.range,
          box_name: cstb.display_name,
          box_id: cstb.box_id,
          construct_sequence: constructSeq,
          construct_id: cst.olab_id,
          design_id: this.olab_id
        };
        // Only print constructSeq once per construct
        constructSeq = "";
        resPmrs.push(pmrObj);
      }
    }
    return resPmrs;
  }

  getOrderPrimers() {
    // Oligo Name, Scale, Purification, Sequence (5' -> 3')
    const resPmrs = [];
    const sortedUniqPmrArray = _.sortBy(this.uniqPmrArray, ["olab_id"]);
    for (let i = 0; i < sortedUniqPmrArray.length; i++) {
      const pmr = sortedUniqPmrArray[i];
      const pmrObj = {
        "Sequence (5' -> 3')": pmr.seq,
        Purification: "",
        Scale: "",
        "Oligo Name": pmr.name
      };
      resPmrs.push(pmrObj);
    }
    return resPmrs;
  }

  static infoLog(dsgn) {
    OlabUtils.infoLog(" - dsgn.olab_id = " + dsgn.olab_id);
    OlabUtils.infoLog(" - dsgn.olab_type = " + dsgn.olab_type);
    OlabUtils.infoLog(" - dsgn.name = " + dsgn.name);
    OlabUtils.infoLog(" - dsgn.desc = " + dsgn.desc);
    OlabUtils.infoLog(" - dsgn.project_id = " + dsgn.project_id);
    OlabUtils.infoLog(" - dsgn.cart_id = " + dsgn.cart_id);
    OlabUtils.infoLog(" - dsgn.configured = " + dsgn.configured);
    OlabUtils.infoLog(" - dsgn.pmr_setting = " + dsgn.pmr_setting);
    OlabUtils.infoLog(" - dsgn.pmr_3p_len = " + dsgn.pmr_3p_len);
    OlabUtils.infoLog(" - dsgn.pmr_5p_len = " + dsgn.pmr_5p_len);
    OlabUtils.infoLog(" - dsgn.package_present = " + dsgn.package_present);
    OlabUtils.infoLog(" - dsgn.cstArray = " + dsgn.cstArray);
    OlabUtils.infoLog(" - dsgn.cstArray.length = " + dsgn.cstArray.length);
    OlabUtils.infoLog(" - dsgn.combPmrArray = " + dsgn.combPmrArray);
    OlabUtils.infoLog(
      " - dsgn.combPmrArray.length = " + dsgn.combPmrArray.length
    );
    OlabUtils.infoLog(" - dsgn.uniqPmrArray = " + dsgn.uniqPmrArray);
    OlabUtils.infoLog(
      " - dsgn.uniqPmrArray.length = " + dsgn.uniqPmrArray.length
    );
  }
}

export { OlabDesign };
